import React from 'react';
const ModalIllustration = ({
  imageUrl
}) => {
  if (!imageUrl) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "ebds-modal__content__body__illustration"
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: ""
  }));
};
export default ModalIllustration;